import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, input, signal } from '@angular/core';
import { MatCard, MatCardFooter, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UtcToUserFormattedPipe } from '../../../../core/pipes/utc-to-user-formatted.pipe';
import { DueDateChipComponent } from '../../../../shared/components/due-date-chip/due-date-chip.component';
import { InlineDatePickerComponent } from '../../../../shared/components/inline-date-picker/inline-date-picker.component';
import { InlineItemStatusChipComponent } from '../../../../shared/components/inline-item-status-chip/inline-item-status-chip.component';
import { StatusCategoryBadgeComponent } from '../../../../shared/components/status-category-badge/status-category-badge.component';
import { EWorkflow, IItemJoins } from '../../../items/items.interface';
import { EItemType } from '../../../settings/fields-field-sets/field-sets/field-sets.interface';

export interface IMyItemCard extends Pick<IItemJoins, 'id' | 'key' | 'name' | 'dueDate' | 'strikeCount'> {
  assigneeName: string | null;
  boardName: string;
  relatedItems: {
    id: number;
    key: string;
    name: string;
  }[];
  status: {
    statusCategory: EWorkflow;
    workflowStepName: string;
  };
  currentWorkflowStepId: number;
  boardItemConfigurationId: number;
}

@Component({
  imports: [
    MatCard,
    NgClass,
    UtcToUserFormattedPipe,
    NgIf,
    MatIcon,
    TranslateModule,
    MatChip,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
    MatCardFooter,
    InlineItemStatusChipComponent,
    InlineDatePickerComponent,
    StatusCategoryBadgeComponent,
    DueDateChipComponent,
  ],
  selector: 'app-my-items-card',
  styleUrl: './my-items-card.component.scss',
  templateUrl: './my-items-card.component.html',
})
export class MyItemsCardComponent {
  @Input() public isDataLoading = false;
  public item = input.required<IMyItemCard>();

  @Output() cardClick: EventEmitter<void> = new EventEmitter();
  @Output() relatedItemClick: EventEmitter<number> = new EventEmitter<number>();
  @Output() reloadListItems = new EventEmitter<void>();

  public readonly isRelatedItemsDisplayed = signal<boolean>(false);
  private readonly show = this.translate.instant('button.show');
  private readonly hide = this.translate.instant('button.hide');
  public readonly showOrHide = computed(() => (this.isRelatedItemsDisplayed() ? this.hide : this.show));
  public readonly EItemType = EItemType;

  constructor(private readonly translate: TranslateService) {}

  public onCardClick(event: MouseEvent): void {
    if (
      this.isDataLoading ||
      (event.target as HTMLElement).closest('.show-hide-related-items-button') ||
      (event.target as HTMLElement).closest('.related-item-container')
    ) {
      return;
    }

    this.cardClick.emit();
  }

  public loadDatatable(): void {
    this.reloadListItems.emit();
  }
}
